import React from 'react';
export default function IssueTracking () {
    return(
        <div className='d-flex h-100 justify-content-center align-items-center '> This page is under development </div>
    )
}